module.exports = (__webpack_require__(2))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-react.js from dll-reference rlink_core
// module id = 0
// module chunks = 0